import {
  Component,
  Input,
  ViewChild,
  AfterViewInit,
  EventEmitter,
  Output,
  forwardRef
} from "@angular/core";
import {
  CropperSettings,
  ImageCropperComponent,
  Bounds
} from "ng2-img-cropper";
import { ModalComponent } from "ng2-bs3-modal/components/modal";
import { ImageService } from "../../shell/shared/image.service";
import { BaseComponent } from "../../core/component/Base.Component";
import { AppConstants } from "../../app.constant";
import { GenEnum } from "../../shell/shared/general.enum";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  moduleId: module.id,
  selector: "ixs-image",
  templateUrl: "image.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImageComponent),
      multi: true
    }
  ]
})
export class ImageComponent extends BaseComponent
  implements AfterViewInit, ControlValueAccessor {
  setDisabledState?(isDisabled: boolean): void {}
  ngAfterViewInit(): void {
    this.imageSource = this.storeInUt
      ? AppConstants.urls.api.base.replace("api/", "") + GenEnum.Image.imageUrl
      : this.localStorage.get("OnlyUrl") + GenEnum.Image.imageUrl;
  }

  constructor(private imageService: ImageService) {
    super();
    this.cropSettings();
  }

  @Input()
  Caption: string = "Upload your image here";

  private innerValue: any = "";

  private onTouchedCallback: () => void;
  private onChangeCallback: (_: any) => void;

  get value(): any {
    return this.innerValue;
  }

  @Input()
  set value(v: any) {
    ;
    if (v !== this.innerValue && v !== null) {
      if (v) {
        this.url = "";
        this.canDelete = false;
        this.imageService.getImageAsFile(v).then(dto => {
          if (dto.IsSuccess) {
            this.url = this.imageSource + dto.Data.filename;
          } else {
            
          }
        });
      } else {
        this.url = "";
        this.canDelete = true;
        //    this.toaster.info('No image data');
      }
      this.innerValue = v;
      //this.onChangeCallback(v);
    }
  }

  onBlur() {
    this.onTouchedCallback();
  }

  writeValue(value: any) {
    ;
    if (!value) {
      this.innerValue = "";
      if (this.innerValue) {
        this.url = "";
        this.canDelete = false;
        this.imageService.getImageAsFile(this.innerValue).then(dto => {
          if (dto.IsSuccess) {
            this.url = this.imageSource + dto.Data.filename;
          } else {
            
          }
        });
      } else {
        this.url = "";
        this.canDelete = true;
        //    this.toaster.info('No image data');
      }
    } else if (value !== this.innerValue) {
      this.value = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  @Input()
  storeInUt: boolean = false;

  imageSource: string;
  imgData: String;
  @Input() canDelete: boolean = true;
  @Output() url: any;
  name: string;
  data1: any;
  cropperSettings1: CropperSettings;
  croppedWidth: number;
  croppedHeight: number;
  @ViewChild("cropper") cropper: ImageCropperComponent;
  @ViewChild("imageModal") public imageModal: ModalComponent;

  cropSettings() {
    this.name = "Angular2";
    this.cropperSettings1 = new CropperSettings();
    // Preview box
    this.cropperSettings1.width = 128;
    this.cropperSettings1.height = 128;
    // Cropped Image Size
    this.cropperSettings1.croppedWidth = 640;
    this.cropperSettings1.croppedHeight = 320;
    // Crop Box size
    this.cropperSettings1.canvasWidth = 200;
    this.cropperSettings1.canvasHeight = 200;

    this.cropperSettings1.minWidth = 10;
    this.cropperSettings1.minHeight = 10;

    this.cropperSettings1.rounded = false;
    this.cropperSettings1.keepAspect = false;

    this.cropperSettings1.cropperDrawSettings.strokeColor =
      "rgba(255,255,255,1)";
    this.cropperSettings1.cropperDrawSettings.strokeWidth = 2;

    this.data1 = {};
  }

  cropped(bounds: Bounds) {
    this.croppedHeight = bounds.bottom - bounds.top;
    this.croppedWidth = bounds.right - bounds.left;
  }

  fileChangeListener($event) {
    const image: any = new Image();
    const file = $event.target.files[0];
    const fileReader: FileReader = new FileReader();
    fileReader.onload = () => {
      image.onload = () => {
        this.cropper.setImage(image);
      };
      image.src = $event.target.result;
    };
    fileReader.readAsDataURL(file);
  }

  openImageModal(): boolean {
    this.imageModal.open();
    return false;
  }

  removePicture(): boolean {
    this.url = "";
    this.cropperSettings1 = new CropperSettings();
    this.data1 = {};
    this.value = undefined;
    this.valueChange.emit({ value: this.value });
    this.canDelete = true;
    return false;
  }

  async uploadImage(url) {
    this.canDelete = false;
    this.imgData = "";
    this.imgData =
      this.data1 && this.data1.image ? this.data1.image : undefined;
    const code = this.imgData ? this.imgData.indexOf(",") : 0;
    const baseImg = this.imgData
      ? this.imgData.slice(code + 1, this.imgData.length)
      : "";
    const dto = await this.imageService.uploadImage(baseImg);
    if (dto.IsSuccess) {
      this.url = this.imageSource + dto.Data.filename;
      this.value = dto.Data.Id;
      this.valueChange.emit({ value: this.value });
      this.data1 = undefined;
      this.imageModal.close();
    } else {
      this.showErrors("Error in uploading image!");
    }
  }

  async setImage(imageid: any) {}

  @Output()
  valueChange: EventEmitter<any> = new EventEmitter<any>();
}



// WEBPACK FOOTER //
// ./src/app/components/image/image.component.ts